<template>
    <div class="page course-page">
        <v-container class="py-0 py-lg-6" :class="{'px-0': phoneOnly}">
            <transition name="fade-transition">
                <course v-if="courseData" :course="courseData.course" :lectures="courseData.lectures" :purchases="courseData.purchases" @loadMore="loadMore" />
            </transition> 
        </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Course from './Course'

export default {
    name: "",
    components: {
        Course
    },
    data(){
        return {
            loading: false,
            courseData: null,
        }
    },
    computed: {
        ...GlobalComputed,
        id(){
            return this.$route.params.id;
        },
        
    },
    methods: {
        ...GlobalMethods,
        loadData(page=null){
            if (!this.loading){
                this.loading = true;

                window.axios.get(`/courses/${this.id}${page ? '?page=' + page : ''}`).then(response=>{
                    this.courseData = response.data;
                    this.loading = false;
                }).catch(e=>{
                    this.loading = false;
                    if (e && e.response && e.response.status === 404){
                        this.$router.push('/not-found')
                    }else{
                        this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    }
                });
            }
        },
        loadMore(page){
            this.loadData(page);
        },
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        }
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>
.stats{
    margin: -8px;
    .col-lg-3, .col-lg-4{
        padding: 8px!important;
    }
}
</style>
